import * as React from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import useStyles from './Styles'
import { Box } from '@mui/material'
import ArrowDown from 'src/assets/svgs/signUp/arrowDown'
import ReactMarkdown from 'react-markdown'
import rehypeSlug from 'rehype-slug'
import rehypeRaw from 'rehype-raw'
interface Props {
  accordianData: {
    title: string
    desc: string
    component?: JSX.Element
  }[]
  gradient: boolean
  content?: JSX.Element
  form?: boolean
}
export default function AccordionComponent({
  accordianData,
  gradient,
  content,
  form,
}: Props) {
  const { classes } = useStyles()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const rehypeRawDec:any = rehypeRaw;
  return (
    <div className={classes.outerContainer}>
      {gradient && <Box className={classes.upperGradient}></Box>}
      <div className={classes.innerContainer}>
        <Box className={classes.accordianContainer}>
          {content ? content : ''}

          {!form &&
            accordianData?.map((item, idx) => {
              return (
                <Accordion
                  className={classes.accordian}
                  elevation={0}
                  key={idx}
                >
                  <AccordionSummary
                    expandIcon={<ArrowDown />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography className={classes.title}>
                      {' '}
                      {item.title}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className={classes.desc}>
                      <ReactMarkdown rehypePlugins={[rehypeRawDec,rehypeSlug]}>
                        {item.desc}
                      </ReactMarkdown>
                    </Typography>
                    {item?.component && item?.component}
                  </AccordionDetails>
                </Accordion>
              )
            })}

          {form &&
            accordianData?.map((item, idx) => {
              return (
                <Accordion
                  className={classes.accordian}
                  elevation={0}
                  key={idx}
                  expanded
                >
                  <AccordionSummary
                    expandIcon={<ArrowDown />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography className={classes.title}>
                      {' '}
                      {item.title}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography className={classes.desc}>
                      <ReactMarkdown rehypePlugins={[rehypeRawDec,rehypeSlug]}>
                        {item.desc}
                      </ReactMarkdown>
                    </Typography>
                    {item?.component && item?.component}
                  </AccordionDetails>
                </Accordion>
              )
            })}
        </Box>
      </div>
      {gradient && <Box className={classes.lowerGradient}></Box>}
    </div>
  )
}
